import { AgGridReact } from "ag-grid-react";
import React, { useRef, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import PDFDownloadButton from "./PDFDownloader";
import moment from "moment";
import { getHeaderClass } from "../../../utils/agGridHelpers";

const DonationReportTable = ({ data, type,reportFormat }) => {
  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const processedData = useMemo(() => {
    const grouped = {};
    const finalData = [];

    // if (type === "bookwise") {
    //   if (!data || !data.report || !data.totals || data.grandTotal == null) {
    //     return null;
    //   }
    //   const { report, totals, grandTotal } = data;
    //   // Group by bookNo
    //   report.forEach((item) => {
    //     const bookNo = item.bookNo;
    //     if (!grouped[bookNo]) grouped[bookNo] = [];
    //     grouped[bookNo].push(item);
    //   });

    //   Object.entries(grouped).forEach(([bookNo, entries]) => {
    //     finalData.push(...entries);

    //     // Append book total row
    //     finalData.push({
    //       rowType: "total",
    //       bookNo: `Total for Book ${bookNo}`,
    //       amount: totals[bookNo],
    //     });
    //   });

    //   // Append grand total row
    //   finalData.push({
    //     rowType: "grandTotal",
    //     bookNo: "Grand Total",
    //     amount: grandTotal,
    //   });

    //   return finalData;
    // }
 if (type === "bookwise") {
  if (!data || !data.report || !data.totals || data.grandTotal == null) {
    return null;
  }
  const { report, totals, grandTotal } = data;
  const finalData = [];

  if (reportFormat === "yearGrouped") {
    // Existing year-grouped display
    const bookGroups = {};
    const bookOrder = [];

    report.forEach((item) => {
      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = {};
        bookOrder.push(item.bookNo);
      }
      const yr =
        item.receiptYear ??
        (item.receiptDate ? new Date(item.receiptDate).getFullYear() : "Unknown");
      if (!bookGroups[item.bookNo][yr]) bookGroups[item.bookNo][yr] = [];
      bookGroups[item.bookNo][yr].push(item);
    });

    bookOrder.forEach((bookNo) => {
      const yearGroups = bookGroups[bookNo];
      Object.keys(yearGroups)
        .sort((a, b) => Number(a) - Number(b))
        .forEach((yr) => {
          finalData.push(...yearGroups[yr]);
          finalData.push({
            rowType: "yearTotal",
            bookNo: `Year ${yr} Total`,
            amount: totals[bookNo]?.[yr] ?? 0,
          });
        });

      finalData.push({
        rowType: "total",
        bookNo: `Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  } else {
    // NEW: yearFilter format — flat display, no year subtotal rows,
    // just what the backend already filtered by the selected year
    const bookGroups = {};
    const bookOrder = [];

    report.forEach((item) => {
      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = [];
        bookOrder.push(item.bookNo);
      }
      bookGroups[item.bookNo].push(item);
    });

    bookOrder.forEach((bookNo) => {
      finalData.push(...bookGroups[bookNo]);
      finalData.push({
        rowType: "total",
        bookNo: `Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  }

  finalData.push({
    rowType: "grandTotal",
    bookNo: "Grand Total",
    amount: grandTotal,
  });

  return finalData;
}
    // if (type === "bookwise-paymodeall") {
    //   if (!data || !data.report || !data.totals || data.grandTotal == null) {
    //     return null;
    //   }

    //   const { report, totals, grandTotal } = data;
    //   const grouped = {};
    //   const finalData = [];

    //   // Group by bookNo and payModea
    //   report.forEach((item) => {
    //     const key = `${item.bookNo}-${item.payMode}`;
    //     if (!grouped[key]) grouped[key] = [];
    //     grouped[key].push(item);
    //   });

    //   // Add data + subtotal rows
    //   Object.entries(grouped).forEach(([key, entries]) => {
    //     const [bookNo, payMode] = key.split("-");
    //     finalData.push(...entries);

    //     const totalForBook = totals[bookNo];
    //     const payModeTotal = totalForBook?.[payMode] ?? "";

    //     finalData.push({
    //       rowType: "total",
    //       bookNo: `Total for Book ${bookNo} (${payMode})`,
    //       amount: payModeTotal,
    //     });
    //   });

    //   // Append grand total row
    //   finalData.push({
    //     rowType: "grandTotal",
    //     bookNo: "Grand Total",
    //     amount: grandTotal,
    //   });

    //   return finalData;
    // }
if (type === "bookwise-paymodeall") {
  if (!data || !data.report || !data.totals || data.grandTotal == null) {
    return null;
  }

  const { report, totals, grandTotal } = data;
  const finalData = [];

  if (reportFormat === "yearGrouped") {
    const bookOrder = [];
    const bookGroups = {};

    report.forEach((item) => {
      const yr =
        item.receiptYear ??
        (item.receiptDate ? new Date(item.receiptDate).getFullYear() : "Unknown");

      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = {};
        bookOrder.push(item.bookNo);
      }
      if (!bookGroups[item.bookNo][yr]) bookGroups[item.bookNo][yr] = {};
      if (!bookGroups[item.bookNo][yr][item.payMode]) {
        bookGroups[item.bookNo][yr][item.payMode] = [];
      }
      bookGroups[item.bookNo][yr][item.payMode].push(item);
    });

    bookOrder.forEach((bookNo) => {
      const yearGroups = bookGroups[bookNo];
      Object.keys(yearGroups)
        .sort((a, b) => Number(a) - Number(b))
        .forEach((yr) => {
          const payModeGroups = yearGroups[yr];
          Object.keys(payModeGroups).forEach((payMode) => {
            finalData.push(...payModeGroups[payMode]);
            const payModeTotal = totals[bookNo]?.years?.[yr]?.[payMode] ?? "";
            finalData.push({
              rowType: "total",
              bookNo: `Total for Book ${bookNo} (${payMode})`,
              amount: payModeTotal,
            });
          });
          finalData.push({
            rowType: "yearTotal",
            bookNo: `Year ${yr} Total`,
            amount: totals[bookNo]?.years?.[yr]?.Total ?? 0,
          });
        });

      finalData.push({
        rowType: "bookTotal",
        bookNo: `Grand Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  } else {
    // NEW: yearFilter format — group by bookNo + payMode only, no year layer
    const bookOrder = [];
    const bookGroups = {};

    report.forEach((item) => {
      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = {};
        bookOrder.push(item.bookNo);
      }
      if (!bookGroups[item.bookNo][item.payMode]) {
        bookGroups[item.bookNo][item.payMode] = [];
      }
      bookGroups[item.bookNo][item.payMode].push(item);
    });

    bookOrder.forEach((bookNo) => {
      const payModeGroups = bookGroups[bookNo];
      // sum payMode totals across the (already year-filtered) records for this book
      const payModeTotals = {};
      Object.entries(payModeGroups).forEach(([payMode, items]) => {
        payModeTotals[payMode] = items.reduce((s, i) => s + (i.amount || 0), 0);
      });

      Object.keys(payModeGroups).forEach((payMode) => {
        finalData.push(...payModeGroups[payMode]);
        finalData.push({
          rowType: "total",
          bookNo: `Total for Book ${bookNo} (${payMode})`,
          amount: payModeTotals[payMode],
        });
      });

      finalData.push({
        rowType: "bookTotal",
        bookNo: `Grand Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  }

  finalData.push({
    rowType: "grandTotal",
    bookNo: "Grand Total",
    amount: grandTotal,
  });

  return finalData;
}

 if (type === "bookwise-paymodewise") {
  if (!data || !data.report || !data.totals || data.grandTotal == null) {
    return null;
  }

  const { report, totals, grandTotal } = data;
  const finalData = [];

  if (reportFormat === "yearGrouped") {
    const bookOrder = [];
    const bookGroups = {};

    report.forEach((item) => {
      const yr =
        item.receiptYear ??
        (item.receiptDate ? new Date(item.receiptDate).getFullYear() : "Unknown");

      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = {};
        bookOrder.push(item.bookNo);
      }
      if (!bookGroups[item.bookNo][yr]) bookGroups[item.bookNo][yr] = {};
      if (!bookGroups[item.bookNo][yr][item.payMode]) {
        bookGroups[item.bookNo][yr][item.payMode] = [];
      }
      bookGroups[item.bookNo][yr][item.payMode].push(item);
    });

    bookOrder.forEach((bookNo) => {
      const yearGroups = bookGroups[bookNo];
      Object.keys(yearGroups)
        .sort((a, b) => Number(a) - Number(b))
        .forEach((yr) => {
          const payModeGroups = yearGroups[yr];
          Object.keys(payModeGroups).forEach((payMode) => {
            finalData.push(...payModeGroups[payMode]);
            const payModeTotal = totals[bookNo]?.years?.[yr]?.[payMode] ?? "";
            finalData.push({
              rowType: "total",
              bookNo: `Total for Book ${bookNo} (${payMode})`,
              amount: payModeTotal,
            });
          });
          finalData.push({
            rowType: "yearTotal",
            bookNo: `Year ${yr} Total`,
            amount: totals[bookNo]?.years?.[yr]?.Total ?? 0,
          });
        });

      finalData.push({
        rowType: "bookTotal",
        bookNo: `Grand Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  } else {
    // NEW: yearFilter format — group by bookNo + payMode only, no year layer
    const bookOrder = [];
    const bookGroups = {};

    report.forEach((item) => {
      if (!bookGroups[item.bookNo]) {
        bookGroups[item.bookNo] = {};
        bookOrder.push(item.bookNo);
      }
      if (!bookGroups[item.bookNo][item.payMode]) {
        bookGroups[item.bookNo][item.payMode] = [];
      }
      bookGroups[item.bookNo][item.payMode].push(item);
    });

    bookOrder.forEach((bookNo) => {
      const payModeGroups = bookGroups[bookNo];
      // sum payMode totals across the (already year-filtered) records for this book
      const payModeTotals = {};
      Object.entries(payModeGroups).forEach(([payMode, items]) => {
        payModeTotals[payMode] = items.reduce((s, i) => s + (i.amount || 0), 0);
      });

      Object.keys(payModeGroups).forEach((payMode) => {
        finalData.push(...payModeGroups[payMode]);
        finalData.push({
          rowType: "total",
          bookNo: `Total for Book ${bookNo} (${payMode})`,
          amount: payModeTotals[payMode],
        });
      });

      finalData.push({
        rowType: "bookTotal",
        bookNo: `Grand Total for Book ${bookNo}`,
        amount: totals[bookNo]?.BookTotal ?? 0,
      });
    });
  }

  finalData.push({
    rowType: "grandTotal",
    bookNo: "Grand Total",
    amount: grandTotal,
  });

  return finalData;
}
    if (type === "fundwise") {

      if (!data || !data.report || data.grandTotal == null) {
        return null;
      }

      const { report, grandTotal } = data;

      let snoCounter = 1;
      const rows = [];

      report.forEach((item) => {
        const { payPurpose, details, totalForPurpose } = item;

        details.forEach((detail) => {
          rows.push({
            sno: snoCounter++,
            payPurpose: payPurpose,
            payMode: detail.payMode,
            totalAmount: detail.totalAmount,
          });
        });

        // Add purpose total row
        rows.push({
          sno: snoCounter++,
          payPurpose: "", // Empty so it doesn't repeat
          payMode: "Total",
          totalAmount: totalForPurpose,
          rowType: "subtotal",
        });
      });

      // Add grand total row
      rows.push({
        sno: snoCounter++,
        payPurpose: "",
        payMode: "Grand Total",
        totalAmount: grandTotal,
        rowType: "grandTotal",
      });

      return rows;
    }

    if (type === "donorwise") {
      if (!data || !data.report || !data.totals || data.grandTotal == null) {
        return null;
      }

      const { report, totals, grandTotal } = data;
      const grouped = {};
      const finalData = [];

      // Step 1: Group donations by donorId
      report.forEach((donation) => {
        const donorId = donation.donorId;
        if (!grouped[donorId]) grouped[donorId] = [];
        grouped[donorId].push(donation);
      });

      // Step 2: Push individual rows and donor total row
      Object.entries(grouped).forEach(([donorId, entries]) => {
        finalData.push(...entries);

        finalData.push({
          rowType: "donorTotal",
          donorId,
          donorName: `Total Amount`,
          amount: totals[donorId],
        });
      });

      // Step 3: Push grand total row
      finalData.push({
        rowType: "grandTotal",
        donorName: "Grand Total",
        amount: grandTotal,
      });

      return finalData;
    }

    return [];
  }, [data, type,reportFormat]);

  // const columnDefsDonation = [
  //   {
  //     headerName: "S.NO",
  //     valueGetter: (params) => {
  //       const api = params.api;
  //       let index = 0;
  //       for (let i = 0; i < params.node.rowIndex; i++) {
  //         const rowNode = api.getDisplayedRowAtIndex(i);
  //         if (!rowNode || rowNode.data?.rowType) continue; // skip total rows
  //         index++;
  //       }
  //       return params.data?.rowType ? "" : index + 1;
  //     },
  //     flex:1,
  //   },
  //   { field: "bookNo", headerName: "Book No", flex:1, filter: "agTextColumnFilter" },
  //    { field: "receiptNo", headerName: "Receipt No", flex:1, filter: "agTextColumnFilter" },
  //   { field: "donorId", headerName: "Donor ID", flex:1, filter: "agTextColumnFilter" },
  //   { field: "donorName", headerName: "Donor Name", flex:1, filter: "agTextColumnFilter" },
  //   {
  //     field: "amount",
  //     headerName: "Amount",
  //     valueFormatter: (params) => {
  //       if (params.value == null) return "";
  //       return new Intl.NumberFormat("en-IN").format(params.value);
  //     }, flex:1, filter: "agTextColumnFilter"
  //   },
  //   { field: "payMode", headerName: "Pay Mode", flex:1 , filter: "agTextColumnFilter"},
  // ];
  const columnDefsDonation = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let index = 0;
        for (let i = 0; i < params.node.rowIndex; i++) {
          const rowNode = api.getDisplayedRowAtIndex(i);
          if (!rowNode || rowNode.data?.rowType) continue;
          index++;
        }
        return params.data?.rowType ? "" : index + 1;
      },
      flex: 1,
    },
    { field: "bookNo", headerName: "Book No", flex: 1, filter: "agTextColumnFilter" },
    { field: "receiptNo", headerName: "Receipt No", flex: 1, filter: "agTextColumnFilter" },
    {
      field: "receiptDate",
      headerName: "Receipt Date",
      flex: 1,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        if (!params.value) return "";
        return moment(params.value).format("DD/MM/YYYY");
      },
    },
    { field: "donorId", headerName: "Donor ID", flex: 1, filter: "agTextColumnFilter" },
    { field: "donorName", headerName: "Donor Name", flex: 1, filter: "agTextColumnFilter" },
    {
      field: "amount",
      headerName: "Amount",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
      flex: 1,
      filter: "agTextColumnFilter",
    },
    { field: "payMode", headerName: "Pay Mode", flex: 1, filter: "agTextColumnFilter" },
  ];

  const columnDefsBookPaymodeAll = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let index = 0;
        for (let i = 0; i < params.node.rowIndex; i++) {
          const rowNode = api.getDisplayedRowAtIndex(i);
          if (!rowNode || rowNode.data?.rowType) continue;
          index++;
        }
        return params.data?.rowType ? "" : index + 1;
      },
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
      flex:1,
    },
    {
      field: "bookNo",
      headerName: "Book No",
      cellRenderer: (params) => {
        if (params.data?.rowType === "total") {
          return `${params.value}`;
        }
        return params.value;
      },
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType === "total"
          ? { fontWeight: "bold", backgroundColor: "#f0f0f0" }
          : null,
    },
     {
      field: "receiptNo",
      headerName: "Receipt No",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
    field: "receiptDate",
    headerName: "Receipt Date",
    flex: 1,
    filter: "agTextColumnFilter",
    cellRenderer: (params) => {
      if (params.data?.rowType || !params.value) return "";
      return moment(params.value).format("DD/MM/YYYY");
    },
    cellStyle: (params) =>
      params.data?.rowType ? { fontWeight: "bold" } : null,
  },
    {
      field: "payMode",
      headerName: "Pay Mode",
      filter: "agTextColumnFilter",
      valueGetter: (params) => {
        return params.data?.rowType === "total" ? "" : params.data?.payMode;
      },
      flex:1,
      cellStyle: (params) =>
        params.data?.rowType === "total"
          ? { backgroundColor: "#f0f0f0" }
          : null,
    },
    {
      field: "donorId",
      headerName: "Donor ID",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
      field: "donorName",
      headerName: "Donor Name",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
      field: "amount",
      headerName: "Amount",
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        if (params.value == null || params.value === "") return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
      cellStyle: (params) => {
        if (params.data?.rowType === "total") {
          return { fontWeight: "bold", backgroundColor: "#f0f0f0" };
        }
        if (params.data?.rowType === "grandTotal") {
          return { fontWeight: "bold", backgroundColor: "#d9ead3" };
        }
        return null;
      },
    },
  ];

  const columnDefsBookPaymodeWise = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let index = 0;
        for (let i = 0; i < params.node.rowIndex; i++) {
          const rowNode = api.getDisplayedRowAtIndex(i);
          if (!rowNode || rowNode.data?.rowType) continue;
          index++;
        }
        return params.data?.rowType ? "" : index + 1;
      },
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
      flex:1,
    },
    {
      field: "bookNo",
      headerName: "Book No",
      cellRenderer: (params) => {
        if (params.data?.rowType === "total") {
          return `${params.value}`;
        }
        return params.value;
      },
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType === "total"
          ? { fontWeight: "bold", backgroundColor: "#f0f0f0" }
          : null,
    },
      {
      field: "receiptNo",
      headerName: "Receipt No",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
  field: "receiptDate",
  headerName: "Receipt Date",
  flex: 1,
  filter: "agTextColumnFilter",
  cellRenderer: (params) => {
    if (params.data?.rowType || !params.value) return "";
    return moment(params.value).format("DD/MM/YYYY");
  },
  cellStyle: (params) =>
    params.data?.rowType ? { fontWeight: "bold" } : null,
},
    {
      field: "payMode",
      headerName: "Pay Mode",
      valueGetter: (params) => {
        return params.data?.rowType === "total" ? "" : params.data?.payMode;
      },
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType === "total"
          ? { backgroundColor: "#f0f0f0" }
          : null,
    },
    {
      field: "donorId",
      headerName: "Donor ID",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
      field: "donorName",
      headerName: "Donor Name",
      flex:1,
      filter: "agTextColumnFilter",
      cellStyle: (params) =>
        params.data?.rowType ? { fontWeight: "bold" } : null,
    },
    {
      field: "amount",
      headerName: "Amount",
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        if (params.value == null || params.value === "") return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
      cellStyle: (params) => {
        if (params.data?.rowType === "total") {
          return { fontWeight: "bold", backgroundColor: "#f0f0f0" };
        }
        if (params.data?.rowType === "grandTotal") {
          return { fontWeight: "bold", backgroundColor: "#d9ead3" };
        }
        return null;
      },
    },
  ];
  const columnDefsPaypurpose = [
   {
  headerName: "S.No.",
  field: "sno",
  flex:1,
  valueGetter: (params) => {
    const api = params.api;
    let index = 0;
    for (let i = 0; i < api.getDisplayedRowCount(); i++) {
      const rowNode = api.getDisplayedRowAtIndex(i);
      if (!rowNode || rowNode.data?.rowType) continue;
      if (rowNode === params.node) {
        return index + 1;
      }
      index++;
    }
    return ""; 
  },
},
    {
      headerName: "Pay Purpose",
      field: "payPurpose",
      cellStyle: (params) => {
        if (
          params.data?.rowType === "subtotal" ||
          params.data?.rowType === "grandTotal"
        ) {
          return { fontWeight: "bold" };
        }
        return {};
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Pay Mode",
      field: "payMode",
      cellStyle: (params) => {
        if (params.data?.rowType === "grandTotal") {
          return { fontWeight: "bold" }; // hide in grand total row
        }
        if (params.data?.rowType === "subtotal") {
          return { fontWeight: "bold" };
        }
        return {};
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Amount",
      field: "totalAmount",
      valueFormatter: (params) =>
        params.value?.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
      cellStyle: (params) => {
        if (
          params.data?.rowType === "subtotal" ||
          params.data?.rowType === "grandTotal"
        ) {
          return { fontWeight: "bold" };
        }
        return {};
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
  ];

  const columnDefsDonorwise = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let index = 0;
        for (let i = 0; i < params.node.rowIndex; i++) {
          const rowNode = api.getDisplayedRowAtIndex(i);
          if (!rowNode || rowNode.data?.rowType) continue;
          index++;
        }
        return params.data?.rowType ? "" : index + 1;
      },
      flex:1,
    },
    {
      field: "donorId",
      headerName: "Donor ID",
      valueGetter: (params) => {
        return params.data?.rowType === "donorTotal" ||
          params.data?.rowType === "grandTotal"
          ? ""
          : params.data?.donorId;
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    { field: "donorName", headerName: "Donor Name", flex:1, filter: "agTextColumnFilter" },
    { field: "city", headerName: "City", flex:1, filter: "agTextColumnFilter" },
    {
      field: "receiptDate",
      headerName: "Receipt Date",
      cellRenderer: (data) => {
        if (data.value) {
          return moment(data.value).format("DD/MM/YYYY");
        } else {
          return "";
        }
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      field: "bookNo",
      headerName: "Book No",
      valueGetter: (params) => {
        return params.data?.rowType === "donorTotal" ||
          params.data?.rowType === "grandTotal"
          ? ""
          : params.data?.bookNo;
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      field: "receiptNo",
      headerName: "Receipt No",
      valueGetter: (params) => {
        return params.data?.rowType === "donorTotal" ||
          params.data?.rowType === "grandTotal"
          ? ""
          : params.data?.receiptNo;
      },
      flex:1,
      filter: "agTextColumnFilter",
    },
    {
      field: "amount",
      headerName: "Amount",
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
    },
  ];

  // const getRowStyle = (params) => {
  //   if (params.data.rowType === "total") {
  //     return { fontWeight: "bold", backgroundColor: "#f0f0f0" };
  //   } else if (params.data.rowType === "grandTotal") {
  //     return { fontWeight: "bold", backgroundColor: "#d0ffd0" };
  //   } else if (params.data.rowType === "donorTotal") {
  //     return { fontWeight: "bold", backgroundColor: "#d0d0ff" };
  //   }
  //   return null;
  // };
const getRowStyle = (params) => {
  if (params.data.rowType === "total") {
    return { fontWeight: "bold", backgroundColor: "#f0f0f0" };
  } else if (params.data.rowType === "yearTotal") {
    return { fontWeight: "bold", backgroundColor: "#e6f0ff" };
  } else if (params.data.rowType === "bookTotal") {
    return { fontWeight: "bold", backgroundColor: "#fff2cc" };
  } else if (params.data.rowType === "grandTotal") {
    return { fontWeight: "bold", backgroundColor: "#d0ffd0" };
  } else if (params.data.rowType === "donorTotal") {
    return { fontWeight: "bold", backgroundColor: "#d0d0ff" };
  }
  return null;
};
  return (
    <div className="ag-theme-alpine" style={{ width: "140vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <PDFDownloadButton data={data} type={type} />
      </div>
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        columnDefs={
          (type === "bookwise" && columnDefsDonation) ||
          (type === "fundwise" && columnDefsPaypurpose) ||
          (type === "donorwise" && columnDefsDonorwise) ||
          (type === "bookwise-paymodeall" && columnDefsBookPaymodeAll) ||
          (type === "bookwise-paymodewise" && columnDefsBookPaymodeWise)
        }
        rowData={processedData ?? []}
        getRowStyle={getRowStyle}
        domLayout="autoHeight"
        defaultColDef={{ headerClass: getHeaderClass }}
        pagination={true}
        paginationPageSize={10}
        paginationPageSizeSelector={[10, 20, 50]}
      />
    </div>
  );
};

export default DonationReportTable;
